module.exports = __webpack_public_path__ + "img/5.3af065ec.png";